export default __webpack_public_path__ + "static/media/type-89.59ad46c3.svg";